import type {
  TEntityType,
  TEntityTypeOption,
  TEntityTypeOptionKeys,
  TEntityTypeOptionPick
} from '../types/entity-types';

export const EntityTypesOptions: Partial<Record<TEntityType, TEntityTypeOption>> = {
  skus: {
    glyph: 'pricetags-outline',
    color: 'blue'
  },
  warehouses: {
    glyph: 'warehouse-outline',
    color: 'green'
  },
  suppliers: {
    glyph: 'storefront-outline',
    color: 'primary'
  },
  workshops: {
    glyph: 'workshop-outline',
    color: 'orange'
  },
  users: {
    glyph: 'people-outline'
  },
  planningOrders: {
    glyph: 'bag-outline'
  }
};

export function getPartialEntityTypesOptions(
  entityTypes: TEntityType[],
  pickProp?: TEntityTypeOptionKeys
) {
  const options: Partial<Record<TEntityType, TEntityTypeOptionPick<typeof pickProp>>> = {};
  entityTypes.forEach((entityType) => {
    const option = EntityTypesOptions[entityType];
    if (option) {
      if (!pickProp) {
        options[entityType] = option;
      } else if (pickProp && option[pickProp]) {
        options[entityType] = option[pickProp];
      }
    }
  });
  return options;
}
